
import React from 'react';

export const AppSpecificTab = () => {
  return (
    <div className="space-y-4">
      <p className="text-muted-foreground">
        Configure settings specific to this application.
      </p>
      
      <div className="p-4 bg-yellow-50 border border-yellow-200 rounded text-sm text-yellow-800">
        Application-specific settings will be implemented in a future update.
      </div>
    </div>
  );
};
